module.exports = __webpack_public_path__ + "static/media/img38.35ffb62b.jpg";